///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { StaticContentDTO } from '../../../generated/shared-types.model';
import { NoteItem } from './release-note-items/release-notes-note-item.model';
import { ReleaseNotesTypes } from '../service/release-notes.types';
import { CompatibilityStaticContent } from './compatibility-static-content.model';
import { LimitationStaticContent } from './limitation-static-content.model';
import { NewReleaseStaticContent } from './release-notes-static-content.model';
import { AboutSikluStaticContentModel } from './about-siklu-static-content.model';

export const fromStaticContent = (staticContent: StaticContentDTO): ExtendedStaticContent => {
    switch (staticContent.type) {
        case ReleaseNotesTypes.NEW_RELEASE:
            return new NewReleaseStaticContent(staticContent);

        case ReleaseNotesTypes.LIMITATION:
            return new LimitationStaticContent(staticContent);

        case ReleaseNotesTypes.PRODUCT_COMPATIBILITY:
            return new CompatibilityStaticContent(staticContent);

        case ReleaseNotesTypes.ABOUT_SIKLU:
            return new AboutSikluStaticContentModel(staticContent);
    }

    return undefined;
};

export interface ExtendedStaticContent extends StaticContentDTO {
    update(item: any): NoteItem;
    getTitleTranslationPath: () => string;
    getTooltipTranslationPath: () => string;
    getPlainObject: () => StaticContentDTO;
}
